export default "__VITE_ASSET__BWpPUlzE__"